import { IReleaseUpdatesItem } from '~/services/api/release/types';

const getReleasesIds = (releases: IReleaseUpdatesItem[]): number[] =>
  (releases || [])?.map(item => item.id);

export default getReleasesIds;
